import React, {FC} from 'react'
import {CellPropsType} from './cellPropsType'

import {BadgeStatus, Stack} from '@mdsol/onex-design'

import './studyGroupUuids.scss'

const StudyGroupUuids: FC<CellPropsType> = ({cell}) => {
  const studyGroupUuids = cell.getValue()

  return (
    <Stack className='study-group-uuids-container' gap={2}>
      {studyGroupUuids.map(studyGroupUuid =>
        <BadgeStatus
          key={`database-studyGroupUuid-${studyGroupUuid}`}
          type='default'
        >
          {studyGroupUuid}
        </BadgeStatus>
      )}
    </Stack>
  )
}

export default StudyGroupUuids
